import { render, staticRenderFns } from "./PagePanel.vue?vue&type=template&id=2ac3c7f8&"
import script from "./PagePanel.vue?vue&type=script&lang=js&"
export * from "./PagePanel.vue?vue&type=script&lang=js&"
import style0 from "./PagePanel.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports